import { mapGetters } from 'vuex';
import {
  getUID,
  getYmDevice,
  isAppWebView,
  isWeiXinBrowser,
} from '@/utils';

const pageBrowsePathMixin = {
  data() {
    return {
      hiddenTime: 0,
      uid: 0,
      baseUrl: `${process.env.VUE_APP_LOG_HOST_DEV}/api/h5track/save`,
    };
  },
  computed: {
    ...mapGetters([
      'browsePathList',
      'richTextScrollList',
    ]),
    platform() {
      if (isAppWebView()) return 'h5-app';
      if (isWeiXinBrowser()) return 'h5-wx';
      return 'h5';
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.hiddenDuration = 0;
        this.recordBrowsePathInfo({
          pageUrl: val.fullPath,
          pageName: val.name,
        });
      },
    },
  },
  methods: {
    getCurrentTime() {
      return new Date().getTime();
    },
    recordBrowsePathInfo(pathInfo) {
      const infoList = [...this.browsePathList, {
        pageUrl: pathInfo.pageUrl,
        pageName: pathInfo.pageName,
        enterTime: this.getCurrentTime(),
        leaveTime: 0,
        stayDuration: 0,
        hiddenDuration: 0,
      }];
      if (infoList.length > 1) {
        infoList[infoList.length - 2].leaveTime = this.getCurrentTime();
      }
      this.$store.dispatch('toggleBrowsePathList', infoList);
    },
    pageBrowsePathHandler() {
      this.browsePathList[this.browsePathList.length - 1].leaveTime = this.getCurrentTime();
      if (this.hiddenTime) {
        // eslint-disable-next-line max-len
        this.browsePathList[this.browsePathList.length - 1].hiddenDuration = Number((this.getCurrentTime() - this.hiddenTime).toFixed(2));
      }
      this.browsePathList.forEach((item) => {
        // eslint-disable-next-line max-len
        item.stayDuration = Number((item.leaveTime - item.enterTime - item.hiddenDuration).toFixed(2));
        if (this.richTextScrollList.length) {
          const richTextScrollItem = this.richTextScrollList[0];
          if (item.pageUrl === richTextScrollItem.pageUrl) {
            item.richTextScroll = richTextScrollItem;
            this.richTextScrollList.shift();
          }
        }
      });
      const browseData = {
        uid: this.uid,
        ymDevice: getYmDevice(),
        platform: this.platform,
        browsePathList: this.browsePathList,
      };
      this.sendDataWithBeacon(this.baseUrl, { browseData: JSON.stringify(browseData) });
      this.removeVisibilityChange();
    },
    onVisibilityChange() {
      this.uid = Number(getUID());
      document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    },
    removeVisibilityChange() {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    },
    visibilityChangeHandler() {
      if (document.visibilityState === 'hidden') {
        this.hiddenTime = this.getCurrentTime();
      } else if (this.hiddenTime) {
        // eslint-disable-next-line max-len
        this.browsePathList[this.browsePathList.length - 1].hiddenDuration = Number((this.getCurrentTime() - this.hiddenTime).toFixed(2));
        this.hiddenTime = 0;
      }
    },
    sendDataWithBeacon(basePath, data) {
      if (!navigator.sendBeacon) return;
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      const status = navigator.sendBeacon(basePath, formData);
      console.log('sendBeacon', status);
    },
  },
  created() {
    this.onVisibilityChange();
  },
};

export default pageBrowsePathMixin;
